import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, Clock, ShieldCheck, Star, ChevronRight, MessageCircle, FileText, TrendingUp, Users, Zap, Smartphone, BookOpen, Gift, AlertTriangle, ArrowRight } from 'lucide-react';
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 58,
    seconds: 29
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-4 text-center my-6" data-id="element-0">
      <div className="bg-neutral-900 border border-yellow-500/30 rounded-lg p-4 min-w-[80px]" data-id="element-1">
        <div className="text-3xl font-black text-yellow-400" data-id="element-2">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <div className="text-xs text-neutral-400 uppercase font-bold mt-1" data-id="element-3">
          HS
        </div>
      </div>
      <div className="text-2xl font-bold text-yellow-500" data-id="element-4">:</div>
      <div className="bg-neutral-900 border border-yellow-500/30 rounded-lg p-4 min-w-[80px]" data-id="element-5">
        <div className="text-3xl font-black text-yellow-400" data-id="element-6">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <div className="text-xs text-neutral-400 uppercase font-bold mt-1" data-id="element-7">
          MIN
        </div>
      </div>
      <div className="text-2xl font-bold text-yellow-500" data-id="element-8">:</div>
      <div className="bg-neutral-900 border border-yellow-500/30 rounded-lg p-4 min-w-[80px]" data-id="element-9">
        <div className="text-3xl font-black text-yellow-400" data-id="element-10">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <div className="text-xs text-neutral-400 uppercase font-bold mt-1" data-id="element-11">
          SEG
        </div>
      </div>
    </div>;
};
const CHECKOUT_URL_19990 = 'https://librofy-store.myshopify.com/checkouts/cn/[LINK_DEL_PLAN_19990]';
const CHECKOUT_URL_27990 = 'https://librofy-store.myshopify.com/checkouts/cn/[LINK_DEL_PLAN_27990]';
const CHECKOUT_URL = 'https://librofy-store.myshopify.com/checkouts/cn/hWNDC2YhgQFxT6QjxhxL0tCE/es-ar?_r=AQABaMWEh2_MnS_qSPgGn5hiRubNit4fMT9glsLEWa7PKZs&cart_link_id=Sy4dIPgn&preview_theme_id=160306823389';
const CTAButton = ({
  children,
  className = '',
  onClick,
  href
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}) => {
  const classes = `w-full md:w-auto bg-green-500 hover:bg-green-400 text-black font-black text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 uppercase tracking-wide ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-12">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={classes} data-id="element-13">
      {children}
    </button>;
};
const Testimonial = ({
  quote,
  author,
  role,
  location
}: {
  quote: string;
  author: string;
  role: string;
  location?: string;
}) => <div className="bg-neutral-900/80 border border-neutral-800 p-6 rounded-2xl relative" data-id="element-14">
    <div className="flex gap-1 mb-4 text-yellow-400" data-id="element-15">
      {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-16" />)}
    </div>
    <p className="text-neutral-300 italic mb-4" data-id="element-17">"{quote}"</p>
    <div className="flex items-center gap-3" data-id="element-18">
      <div className="w-10 h-10 bg-neutral-800 rounded-full flex items-center justify-center text-neutral-400 font-bold" data-id="element-19">
        {author.substring(0, 2)}
      </div>
      <div data-id="element-20">
        <div className="font-bold text-white" data-id="element-21">{author}</div>
        <div className="text-sm text-neutral-500" data-id="element-22">
          {role} {location && `· 📍 ${location}`}
        </div>
      </div>
    </div>
  </div>;
export function App() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-black text-neutral-200 font-sans selection:bg-yellow-500/30" data-id="element-23">
      {/* Top Banner */}
      <div className="bg-[#FFD700] text-black text-center py-2 px-4 text-sm font-bold uppercase tracking-wider" data-id="element-24">
        Creado por agentes. Para agentes. Dejá de ser el agente que persigue
        clientes.
      </div>

      {/* Hero Section */}
      <section className="pt-16 pb-20 px-4 max-w-5xl mx-auto text-center" data-id="element-25">
        <p className="text-[#FFD700] text-sm md:text-base font-bold uppercase tracking-[0.25em] mb-6" data-id="element-26">
          El Megapack Definitivo
        </p>

        <h1 className="text-4xl md:text-6xl font-black text-white leading-tight tracking-tight" data-id="element-27">
          Agente Seguro PRO
        </h1>

        {/* Product Mockup */}
        <div className="relative mt-16 mb-12" data-id="element-28">
          <div className="absolute inset-0 bg-[#FFD700]/10 blur-3xl rounded-full scale-90" data-id="element-29" />
          <img src="https://cdn.magicpatterns.com/uploads/4rmPvaGa8nno8DRSnJgqJi/heylloyd-image-1782253097775.png" alt="Megapack Agentes de Seguros PRO — los 6 módulos, dashboards, sistema de seguimiento y bonos incluidos" className="relative w-full max-w-4xl mx-auto rounded-2xl" data-id="element-30" />
        </div>

        <p className="text-xl md:text-2xl text-neutral-300 font-normal max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-31">
          Cerrá pólizas en la mitad del tiempo y recuperá tus renovaciones con
          IA.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-12 text-neutral-300 font-medium" data-id="element-32">
          <div className="flex items-center gap-2" data-id="element-33">
            <CheckCircle2 className="text-green-500" size={20} data-id="element-34" /> Scripts listos
          </div>
          <div className="hidden md:block text-neutral-700" data-id="element-35">•</div>
          <div className="flex items-center gap-2" data-id="element-36">
            <CheckCircle2 className="text-green-500" size={20} data-id="element-37" /> Sistemas de
            seguimiento
          </div>
          <div className="hidden md:block text-neutral-700" data-id="element-38">•</div>
          <div className="flex items-center gap-2" data-id="element-39">
            <CheckCircle2 className="text-green-500" size={20} data-id="element-40" /> Cierre de
            objeciones
          </div>
        </div>

        <div className="text-lg text-neutral-400 mb-10 font-medium" data-id="element-41">
          Sin perseguir. Sin improvisar.{' '}
          <span className="text-white border-b-2 border-red-500" data-id="element-42">
            Sin perder domingos.
          </span>
        </div>

        <CTAButton onClick={scrollToPricing} className="mx-auto mb-8 animate-pulse" data-id="element-43">
          💥 QUIERO MI MEGAPACK AHORA
        </CTAButton>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-neutral-500 font-medium" data-id="element-44">
          <div className="flex items-center gap-1" data-id="element-45">
            <ShieldCheck size={16} data-id="element-46" /> Garantía 45 días
          </div>
          <div className="flex items-center gap-1" data-id="element-47">
            <CheckCircle2 size={16} data-id="element-48" /> Pago seguro Mercado Pago
          </div>
          <div className="flex items-center gap-1" data-id="element-49">
            <FileText size={16} data-id="element-50" /> 100% PDF
          </div>
          <div className="flex items-center gap-1" data-id="element-51">
            <Zap size={16} data-id="element-52" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-1" data-id="element-53">🇦🇷 Para Argentina</div>
        </div>
      </section>

      {/* Hero Testimonials */}
      <section className="py-12 bg-neutral-950 border-y border-neutral-900" data-id="element-54">
        <div className="max-w-6xl mx-auto px-4" data-id="element-55">
          <div className="text-center mb-10" data-id="element-56">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-57">
              Lo que dicen los agentes
            </h3>
            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold" data-id="element-58">
              <Star fill="currentColor" size={20} data-id="element-59" />
              <Star fill="currentColor" size={20} data-id="element-60" />
              <Star fill="currentColor" size={20} data-id="element-61" />
              <Star fill="currentColor" size={20} data-id="element-62" />
              <Star fill="currentColor" size={20} data-id="element-63" />
              <span className="text-neutral-400 ml-2" data-id="element-64">
                4.9/5 calificación (+500 agentes)
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-65">
            <Testimonial quote="Tenía 3 renovaciones vencidas por semana. Con el sistema de seguimiento del Megapack recuperé 11 pólizas en el primer mes. Nunca más pierdo una renovación." author="Martín G." role="Agente Independiente" location="Buenos Aires" data-id="element-66" />
            <Testimonial quote="El guión de manejo de objeciones me cambió la vida. Antes cedía en el precio siempre. Ahora cierro sin descuento y el cliente queda conforme." author="Laura P." role="Agente de Seguros" location="Córdoba" data-id="element-67" />
            <Testimonial quote="Lo que más me sorprendió fue el protocolo de WhatsApp. Mis clientes ahora saben cuándo y cómo escribirme. Recuperé mis domingos." author="Roberto M." role="Agente Independiente" location="Rosario" data-id="element-68" />
          </div>
        </div>
      </section>

      {/* Problem Agitation */}
      <section className="py-24 px-4 max-w-4xl mx-auto" data-id="element-69">
        <div className="text-center mb-16" data-id="element-70">
          <h2 className="text-3xl md:text-5xl font-black text-red-500 mb-6 uppercase tracking-tight" data-id="element-71">
            ❌ ¿CUÁNTOS DOMINGOS A LAS 11 DE LA NOCHE MÁS VAS A PASAR ASÍ?
          </h2>
          <p className="text-xl text-neutral-300" data-id="element-72">
            Estudiaste para vender seguros y asesorar a tus clientes.
          </p>
          <p className="text-xl text-neutral-300 font-bold mt-2" data-id="element-73">
            Terminaste apagando incendios por WhatsApp.
          </p>
        </div>

        <div className="space-y-6 mb-16" data-id="element-74">
          {[{
          title: "El cliente 'fantasma'",
          desc: 'Te hizo laburar 2 horas cotizando un Todo Riesgo y te dejó en visto por $2.000 de diferencia.'
        }, {
          title: 'Esclavitud del WhatsApp',
          desc: 'Siniestros un sábado a la noche y consultas un domingo al mediodía. No sos dueño de tu tiempo, sos un cadete de tu cartera.'
        }, {
          title: 'Inflación vs Comisiones',
          desc: 'Laburás el doble para ganar lo mismo que hace 6 meses. Sin escala, tu negocio se achica.'
        }, {
          title: 'Miedo a la obsolescencia',
          desc: 'Ver cómo los brokers digitales te roban clientes porque ellos sí usan tecnología.'
        }].map((item, i) => <div key={i} className="bg-neutral-900 border border-red-900/30 p-6 rounded-xl flex gap-4" data-id="element-75">
              <AlertTriangle className="text-red-500 shrink-0 mt-1" size={24} data-id="element-76" />
              <div data-id="element-77">
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-78">
                  {item.title}
                </h4>
                <p className="text-neutral-400 leading-relaxed" data-id="element-79">{item.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-80">
          <p className="text-2xl font-bold text-white mb-4" data-id="element-81">
            La IA avanzando… y vos sin sistema.
          </p>
          <p className="text-xl text-neutral-400 mb-8" data-id="element-82">
            No estás atrasado.{' '}
            <span className="text-yellow-400 font-bold" data-id="element-83">
              Estás trabajando con el modelo equivocado.
            </span>
          </p>
          <h3 className="text-3xl font-black text-white" data-id="element-84">
            ¿Y si este fuera el último domingo que pasás así?
          </h3>
        </div>
      </section>

      {/* Product Intro */}
      <section className="py-24 bg-gradient-to-b from-neutral-950 to-neutral-900 border-t border-neutral-800" data-id="element-85">
        <div className="max-w-5xl mx-auto px-4" data-id="element-86">
          <div className="text-center mb-16" data-id="element-87">
            <div className="text-yellow-500 font-bold tracking-widest uppercase mb-4" data-id="element-88">
              LIBROFY.STORE™
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-white mb-6" data-id="element-89">
              MEGAPACK AGENTES DE SEGUROS PRO
            </h2>
            <p className="text-2xl text-neutral-400" data-id="element-90">
              Todo el sistema listo para transformar tu manera de trabajar.
            </p>
          </div>

          <h3 className="text-2xl font-bold text-center text-white mb-10 flex items-center justify-center gap-3" data-id="element-91">
            <BookOpen className="text-yellow-500" data-id="element-92" /> LO QUE INCLUYE EL MEGAPACK
          </h3>

          <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-93">
            {[{
            icon: '📘',
            title: 'Módulo 1 — El Agente que Cierra',
            desc: 'Mentalidad de cierre, configuración de IA para seguros, protocolo de primera consulta, matriz de detección de necesidades del cliente.'
          }, {
            icon: '📗',
            title: 'Módulo 2 — Sistema de Seguimiento Inteligente',
            desc: 'Scripts de seguimiento con IA, sistema de recordatorios automáticos, protocolo de renovaciones, mensajes listos para recuperar clientes indecisos.'
          }, {
            icon: '📙',
            title: 'Módulo 3 — Cierre de Objeciones PRO',
            desc: 'Los 10 guiones para las objeciones más comunes, técnica de anclaje de precio, respuestas para el cliente que "lo piensa", sistema de cierre en 3 pasos.'
          }, {
            icon: '📕',
            title: 'Módulo 4 — Gestión de Clientes Sin Estrés',
            desc: 'Protocolo de WhatsApp Business PRO, sistema de etiquetas A/B/C, regla de las 24 horas, kit de bienvenida para nuevos clientes, guiones para situaciones difíciles.'
          }, {
            icon: '📓',
            title: 'Módulo 5 — Automatización de Trámites con IA',
            desc: 'Sistema de carga de documentación automatizada, prompts para redactar mails profesionales, plantillas para comunicación con aseguradoras, checklist de cierre de póliza.'
          }, {
            icon: '📔',
            title: 'Módulo 6 — El Agente del Futuro · Plan 90 Días',
            desc: 'Auditoría de tu cartera actual, 5 hábitos diarios de un agente exitoso, sistema de referidos en 3 pasos, estrategia de contenido en Instagram, plan de crecimiento de cartera.'
          }].map((mod, i) => <div key={i} className="bg-neutral-950 border border-neutral-800 p-8 rounded-2xl hover:border-yellow-500/50 transition-colors" data-id="element-94">
                <div className="text-4xl mb-4" data-id="element-95">{mod.icon}</div>
                <h4 className="text-xl font-bold text-white mb-3" data-id="element-96">
                  {mod.title}
                </h4>
                <p className="text-neutral-400 leading-relaxed" data-id="element-97">{mod.desc}</p>
              </div>)}
          </div>

          <div className="bg-neutral-800/50 rounded-2xl p-8 border border-neutral-700 max-w-3xl mx-auto" data-id="element-98">
            <h4 className="text-lg font-bold text-white mb-6 text-center uppercase" data-id="element-99">
              Cada módulo incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-100">
              <div className="flex items-center gap-3 text-neutral-300" data-id="element-101">
                <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-102" />{' '}
                Objetivos claros por capítulo
              </div>
              <div className="flex items-center gap-3 text-neutral-300" data-id="element-103">
                <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-104" />{' '}
                Scripts listos para copiar y pegar
              </div>
              <div className="flex items-center gap-3 text-neutral-300" data-id="element-105">
                <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-106" />{' '}
                Casos prácticos del contexto argentino
              </div>
              <div className="flex items-center gap-3 text-neutral-300" data-id="element-107">
                <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-108" />{' '}
                Checklists de implementación inmediata
              </div>
              <div className="flex items-center gap-3 text-neutral-300 sm:col-span-2 justify-center mt-2 text-center" data-id="element-109">
                <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-110" />{' '}
                100% adaptados al mercado argentino: SSN, aseguradoras locales y
                la jerga de tus clientes
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-24 bg-neutral-950 relative overflow-hidden" data-id="element-111">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-px bg-gradient-to-r from-transparent via-yellow-500 to-transparent opacity-50" data-id="element-112"></div>
        <div className="max-w-5xl mx-auto px-4" data-id="element-113">
          <div className="text-center mb-16" data-id="element-114">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-4 flex items-center justify-center gap-4" data-id="element-115">
              <Gift className="text-yellow-500" size={40} data-id="element-116" />4 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-xl text-yellow-500 font-bold uppercase tracking-widest" data-id="element-117">
              Siempre Incluidos
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-118">
            {[{
            num: '01',
            title: 'Guiones de WhatsApp para Situaciones Difíciles',
            desc: '20 guiones listos para copiar y pegar en WhatsApp Business para las situaciones más incómodas: clientes que piden descuento, consultas fuera de horario, siniestros urgentes, clientes que amenazan con irse. Nunca más quedarte sin palabras.',
            val: '$8.000'
          }, {
            num: '02',
            title: 'Calculadora de Comisiones PRO',
            desc: 'Planilla Excel con fórmulas para calcular tu comisión real por póliza, el impacto de la inflación en tu cartera y la proyección de ingresos con el nuevo sistema de trabajo. Completás tus números y te dice exactamente cuánto podés ganar.',
            val: '$9.000'
          }, {
            num: '03',
            title: 'Biblioteca de Prompts de Seguros Express',
            desc: 'Los 10 prompts más usados para cotizaciones, seguimientos y renovaciones listos en una sola hoja de referencia rápida. Imprimible. Para tener al lado del teclado.',
            val: '$8.000'
          }, {
            num: '04',
            title: 'Plantillas de Mail Profesional',
            desc: '15 mails listos para las situaciones más frecuentes: seguimiento de cotización, recordatorio de renovación, comunicación de siniestro, respuesta a objeciones y más. Solo cambiás el nombre y enviás.',
            val: '$10.000'
          }].map((bono, i) => <div key={i} className="bg-gradient-to-br from-neutral-900 to-neutral-950 border border-yellow-500/20 p-8 rounded-2xl relative group hover:border-yellow-500/50 transition-all" data-id="element-119">
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-yellow-500 text-black font-black flex items-center justify-center rounded-xl rotate-[-10deg] group-hover:rotate-0 transition-transform" data-id="element-120">
                  {bono.num}
                </div>
                <h4 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-121">
                  {bono.title}
                </h4>
                <p className="text-neutral-400 mb-6 leading-relaxed" data-id="element-122">
                  {bono.desc}
                </p>
                <div className="inline-block bg-neutral-950 border border-neutral-800 rounded-lg px-4 py-2" data-id="element-123">
                  <span className="text-neutral-500 line-through mr-2" data-id="element-124">
                    Valor: {bono.val}
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-125">→ GRATIS</span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-24 bg-black relative" data-id="element-126">
        <div className="max-w-6xl mx-auto px-4" data-id="element-127">
          <div className="text-center mb-12" data-id="element-128">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase" data-id="element-129">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-130" />
            <h3 className="text-2xl font-bold text-yellow-500 mt-12 mb-4" data-id="element-131">
              💰 ELEGÍ TU MEGAPACK
            </h3>
            <p className="text-neutral-300 max-w-xl mx-auto mb-8 text-lg" data-id="element-132">
              Menos de lo que cobrás por una sola comisión de un seguro de auto
              medio.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-133">
            {/* Standard Plan */}
            <div className="bg-neutral-900 border border-neutral-800 rounded-3xl p-8 flex flex-col relative" data-id="element-134">
              <div className="text-4xl mb-4" data-id="element-135">📘</div>
              <h3 className="text-2xl font-black text-white mb-2" data-id="element-136">
                MEGAPACK AGENTES DE SEGUROS PRO
              </h3>
              <p className="text-neutral-400 mb-6 font-medium" data-id="element-137">
                Módulos + 4 Bonos
              </p>

              <div className="bg-neutral-950 rounded-xl p-4 mb-8" data-id="element-138">
                <p className="text-sm text-neutral-300" data-id="element-139">
                  <span className="text-yellow-500 font-bold" data-id="element-140">Ideal para:</span>{' '}
                  Agente independiente que quiere cerrar más pólizas, recuperar
                  renovaciones y manejar clientes difíciles con IA.
                </p>
              </div>

              <div className="mb-8" data-id="element-141">
                <div className="text-neutral-500 line-through text-xl mb-1" data-id="element-142">
                  $51.000
                </div>
                <div className="text-5xl font-black text-white flex items-baseline gap-2" data-id="element-143">
                  $19.990{' '}
                  <span className="text-xl text-neutral-400 font-bold" data-id="element-144">
                    ARS
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-145">
                <CTAButton href={CHECKOUT_URL} className="w-full text-sm md:text-base py-4" data-id="element-146">
                  QUIERO MI MEGAPACK PRO
                </CTAButton>
              </div>
            </div>

            {/* PRO + AI Plan */}
            <div className="bg-gradient-to-b from-neutral-900 to-neutral-950 border-2 border-yellow-500 rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_50px_rgba(234,179,8,0.15)]" data-id="element-147">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#FFD700] text-black font-black px-6 py-2 rounded-full uppercase tracking-widest text-sm whitespace-nowrap shadow-[0_0_25px_rgba(255,215,0,0.5)]" data-id="element-148">
                ⭐ Más Elegido
              </div>
              <div className="text-4xl mb-4" data-id="element-149">⭐</div>
              <h3 className="text-2xl font-black text-white mb-2" data-id="element-150">
                MEGAPACK PRO + ASISTENTE DE IA
              </h3>
              <p className="text-yellow-500 mb-6 font-bold" data-id="element-151">
                Módulos + 4 Bonos + Sistema Completo de Automatización
              </p>

              <div className="bg-neutral-950 rounded-xl p-4 mb-8 border border-yellow-500/20" data-id="element-152">
                <p className="text-sm text-neutral-300" data-id="element-153">
                  <span className="text-yellow-500 font-bold" data-id="element-154">Ideal para:</span>{' '}
                  Agente que además quiere automatizar todos sus trámites,
                  escalar su cartera y convertirse en un agente de alto
                  rendimiento.
                </p>
              </div>

              <div className="mb-8" data-id="element-155">
                <div className="text-neutral-500 line-through text-xl mb-1" data-id="element-156">
                  $69.000
                </div>
                <div className="text-5xl font-black text-white flex items-baseline gap-2" data-id="element-157">
                  $27.990{' '}
                  <span className="text-xl text-neutral-400 font-bold" data-id="element-158">
                    ARS
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-159">
                <CTAButton href={CHECKOUT_URL} className="w-full text-sm md:text-base py-4 bg-yellow-500 hover:bg-yellow-400 shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)]" data-id="element-160">
                  QUIERO EL PRO + ASISTENTE DE IA
                </CTAButton>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-24 bg-neutral-950 border-t border-neutral-900" data-id="element-161">
        <div className="max-w-5xl mx-auto px-4" data-id="element-162">
          <div className="text-center mb-16" data-id="element-163">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-164">
              🕊️ ¿QUÉ AGREGA EL MEGAPACK PRO + ASISTENTE DE IA?
            </h2>
          </div>

          <div className="overflow-x-auto" data-id="element-165">
            <table className="w-full text-left border-collapse" data-id="element-166">
              <thead data-id="element-167">
                <tr data-id="element-168">
                  <th className="p-4 border-b border-neutral-800 text-red-400 font-bold w-1/2 bg-red-950/10" data-id="element-169">
                    ❌ Sin Sistema
                  </th>
                  <th className="p-4 border-b border-neutral-800 text-green-400 font-bold w-1/2 bg-green-950/10" data-id="element-170">
                    ✅ Con Sistema
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm md:text-base" data-id="element-171">
                {[['Invisible en redes: Los brokers digitales te roban la zona.', 'Autoridad Digital: Sos el referente que los clientes buscan.'], ['Angustia financiera: No saber si el mes que viene entran clientes nuevos.', 'Cierres Predecibles: Sistema de prospección funcionando 24/7.'], ['Viernes perdidos: Limpiando Excels y cargando documentación a mano.', 'Libertad Real: La IA gestiona el papeleo mientras vos vivís.']].map((row, i) => <tr key={i} className="border-b border-neutral-800/50 hover:bg-neutral-900/50 transition-colors" data-id="element-172">
                    <td className="p-4 text-neutral-400 bg-red-950/5" data-id="element-173">
                      {row[0]}
                    </td>
                    <td className="p-4 text-green-400 font-medium bg-green-950/5" data-id="element-174">
                      {row[1]}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="mt-16 bg-neutral-900 border border-yellow-500/30 rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-175">
            <h3 className="text-xl font-black text-yellow-500 mb-6 text-center uppercase" data-id="element-176">
              EL ASISTENTE DE IA INCLUYE:
            </h3>
            <div className="space-y-4" data-id="element-177">
              {['30 posts redactados con IA para Instagram listos para publicar', 'Bio y perfil optimizado para Instagram', 'Sistema de seguimiento automático de clientes', 'Template de propuesta comercial profesional editable', 'Sistema de referidos en 3 pasos con mensajes listos', 'Guía de especialización por tipo de seguro', 'Mini-Curso "Tu Primera Semana con IA" en video (20 minutos)'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-178">
                  <CheckCircle2 className="text-green-500 shrink-0 mt-0.5" size={20} data-id="element-179" />
                  <span className="text-neutral-200" data-id="element-180">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* More Testimonials */}
      <section className="py-24 bg-black" data-id="element-181">
        <div className="max-w-6xl mx-auto px-4" data-id="element-182">
          <h2 className="text-3xl font-black text-center text-white mb-12 uppercase" data-id="element-183">
            MÁS AGENTES QUE YA LO TIENEN
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-184">
            <Testimonial quote="El sistema de renovaciones me salvó la cartera. Recuperé 8 pólizas en las primeras dos semanas que se me iban a vencer. Ese solo módulo ya justificó toda la inversión." author="Cecilia R." role="Megapack PRO + Asistente de IA" location="Mendoza" data-id="element-185" />
            <Testimonial quote="Subí mis cierres un 60% en dos meses usando el protocolo de objeciones. Antes cedía en el precio siempre. Ahora cierro sin descuento y el cliente queda satisfecho." author="Roberto M." role="Agente Independiente" location="Buenos Aires" data-id="element-186" />
            <Testimonial quote="Mis clientes ahora reciben un mensaje de seguimiento profesional y personalizado. Nadie me volvió a decir que era caro. El mensaje lo armo en 2 minutos con el prompt y parece hecho por un agente de alto nivel." author="Sofía C." role="Agente de Seguros" location="La Plata" data-id="element-187" />
            <Testimonial quote="El protocolo de WhatsApp fue un antes y un después. Lo que me llevaba 2 horas respondiendo mensajes ahora lo resuelvo en 20 minutos. Recuperé mis tardes." author="Pablo A." role="Agente Independiente" location="Neuquén" data-id="element-188" />
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-20 bg-gradient-to-r from-neutral-900 to-neutral-950 border-y border-neutral-800" data-id="element-189">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-190">
          <ShieldCheck className="text-yellow-500 mx-auto mb-6" size={64} data-id="element-191" />
          <h2 className="text-3xl md:text-5xl font-black text-white mb-8 uppercase" data-id="element-192">
            🛡️ GARANTÍA 45 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="text-xl text-neutral-300 space-y-4 mb-8" data-id="element-193">
            <p data-id="element-194">Abrís los módulos. Usás los scripts.</p>
            <p data-id="element-195">Aplicás los protocolos en tu trabajo real.</p>
            <p className="text-white font-bold" data-id="element-196">
              Si en 45 días no es exactamente lo que esperabas: devolución del
              100% del dinero.
            </p>
            <p className="text-neutral-400" data-id="element-197">
              Sin formularios. Sin drama. Sin preguntas.
            </p>
          </div>
          <div className="inline-block bg-neutral-950 border border-neutral-800 text-neutral-400 px-6 py-3 rounded-full font-bold" data-id="element-198">
            Tasa de devoluciones: menos del 1%.
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-black" data-id="element-199">
        <div className="max-w-3xl mx-auto px-4" data-id="element-200">
          <h2 className="text-3xl font-black text-center text-white mb-12 uppercase" data-id="element-201">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="space-y-6" data-id="element-202">
            {[{
            q: '¿Sirve si soy agente independiente o solo para agencias grandes?',
            a: 'Sí. El Megapack está diseñado especialmente para agentes independientes. Todo el sistema está pensado para que una sola persona pueda implementarlo desde el día uno.'
          }, {
            q: '¿Cómo recibo el material?',
            a: 'Apenas confirmado el pago recibís el acceso por mail en menos de 5 minutos.'
          }, {
            q: '¿Qué lo diferencia de los cursos de seguros genéricos?',
            a: 'No es un curso teórico. Es un sistema listo para usar hoy con scripts, prompts y plantillas adaptadas al mercado asegurador argentino.'
          }, {
            q: '¿Necesito saber usar IA para aplicarlo?',
            a: 'No. Todo está explicado paso a paso. Si sabés usar WhatsApp, podés usar este sistema.'
          }, {
            q: '¿Funciona para cualquier tipo de seguro?',
            a: 'Sí. Los sistemas y scripts están adaptados para autos, vida, hogar, comercio y más.'
          }, {
            q: '¿Tiene garantía real?',
            a: '45 días. Sin preguntas. Sin formularios. Devolución del 100%.'
          }].map((faq, i) => <div key={i} className="bg-neutral-900 border border-neutral-800 p-6 rounded-xl" data-id="element-203">
                <h4 className="text-lg font-bold text-white mb-2 flex gap-3" data-id="element-204">
                  <span className="text-yellow-500" data-id="element-205">Q.</span> {faq.q}
                </h4>
                <p className="text-neutral-400 pl-7" data-id="element-206">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Cost of Inaction */}
      <section className="py-24 bg-neutral-950 border-t border-neutral-900" data-id="element-207">
        <div className="max-w-4xl mx-auto px-4" data-id="element-208">
          <h2 className="text-3xl md:text-5xl font-black text-center text-white mb-16 uppercase" data-id="element-209">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-210">
            <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-8" data-id="element-211">
              <h3 className="text-xl font-bold text-red-500 mb-6 text-center uppercase" data-id="element-212">
                Sin Megapack
              </h3>
              <ul className="space-y-4" data-id="element-213">
                {['Clientes indecisos sin seguimiento', 'Renovaciones sin sistema de aviso', 'Sin guión para manejar objeciones', 'WhatsApp disponible 24/7', 'Trámites manuales todos los días', 'Sin sistema de referidos', 'Sin prompts para seguimiento'].map((item, i) => <li key={i} className="flex items-center gap-3 text-neutral-300" data-id="element-214">
                    <XCircle className="text-red-500 shrink-0" size={20} data-id="element-215" />{' '}
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8" data-id="element-216">
              <h3 className="text-xl font-bold text-neutral-400 mb-6 text-center uppercase" data-id="element-217">
                Costo real
              </h3>
              <ul className="space-y-4" data-id="element-218">
                {['Pólizas perdidas que ya eran tuyas', 'Cartera que se achica sola', 'Descuentos que te comen las comisiones', 'Domingos sin familia ni descanso', 'Horas perdidas que podrías usar vendiendo', 'El mismo ciclo el año que viene', 'Clientes que se pierden en silencio'].map((item, i) => <li key={i} className="flex items-center gap-3 text-neutral-400" data-id="element-219">
                    <ArrowRight className="text-neutral-600 shrink-0" size={20} data-id="element-220" />{' '}
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center" data-id="element-221">
            <p className="text-2xl md:text-3xl font-black text-white mb-4 max-w-3xl mx-auto leading-snug" data-id="element-222">
              El próximo domingo puede ser diferente. O seguís apagando
              incendios, o empezás a{' '}
              <span className="text-[#FFD700]" data-id="element-223">liderar tu estudio.</span>
            </p>
            <p className="text-neutral-400 max-w-2xl mx-auto mb-12 mt-6" data-id="element-224">
              Los que entren hoy no solo compran el Megapack: entran al
              ecosistema de Librofy.store. Eso incluye acceso a futuros
              materiales exclusivos que iremos liberando para miembros.
            </p>
            <CTAButton onClick={scrollToPricing} className="mx-auto animate-pulse" data-id="element-225">
              QUIERO MI MEGAPACK AHORA
            </CTAButton>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-16 border-t border-neutral-900" data-id="element-226">
        <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-227">
          {/* Trust strip */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-12 pb-12 border-b border-neutral-900" data-id="element-228">
            <div className="flex items-center gap-3 bg-neutral-950 border border-[#FFD700]/30 rounded-2xl px-5 py-4" data-id="element-229">
              <ShieldCheck className="text-[#FFD700]" size={36} data-id="element-230" />
              <div className="text-left" data-id="element-231">
                <div className="text-white font-black leading-tight" data-id="element-232">
                  GARANTÍA 45 DÍAS
                </div>
                <div className="text-neutral-500 text-xs uppercase tracking-wider" data-id="element-233">
                  Sin preguntas · Devolución 100%
                </div>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-234">
              <span className="bg-[#009EE3] text-white text-sm font-bold px-4 py-2 rounded-lg" data-id="element-235">
                Mercado Pago
              </span>
              <span className="bg-neutral-950 border border-neutral-800 text-neutral-300 text-sm font-medium px-4 py-2 rounded-lg flex items-center gap-2" data-id="element-236">
                <CheckCircle2 size={16} className="text-green-500" data-id="element-237" /> Tarjeta de
                crédito / débito
              </span>
              <span className="bg-neutral-950 border border-neutral-800 text-neutral-300 text-sm font-medium px-4 py-2 rounded-lg flex items-center gap-2" data-id="element-238">
                <ShieldCheck size={16} className="text-green-500" data-id="element-239" /> Pago 100%
                seguro
              </span>
            </div>
          </div>

          <div className="text-2xl font-black text-white tracking-widest mb-4" data-id="element-240">
            LIBROFY.STORE™
          </div>
          <p className="text-neutral-400 mb-2" data-id="element-241">
            El sistema N°1 de automatización profesional para agentes de seguros
            independientes de Argentina.
          </p>
          <p className="text-yellow-500 font-bold mb-12" data-id="element-242">
            Porque vender seguros no debería costarte todos los domingos de tu
            vida.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-neutral-500 text-sm mb-12" data-id="element-243">
            <a href="mailto:hola@librofy.store" className="hover:text-white transition-colors" data-id="element-244">
              📧 hola@librofy.store
            </a>
            <span className="hover:text-white transition-colors cursor-pointer" data-id="element-245">
              📲 @librofy.store
            </span>
            <span className="hover:text-white transition-colors cursor-pointer" data-id="element-246">
              🌐 www.librofy.store
            </span>
          </div>

          <div className="text-neutral-600 text-sm mb-8" data-id="element-247">
            <p className="italic mb-4" data-id="element-248">
              "El próximo domingo a las 11 de la noche puede ser diferente." —
              Librofy.store
            </p>
            <p data-id="element-249">© Librofy™ 2024 — Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>;
}